<template>
  <div class="logo-container">
    <div class="index-help">
      <div class="left">
        <div class="left-btitle">睿泽助力 成就更好的你</div>
        <div class="left-stitle">
          他们和您一样，选择信任睿泽；<br />
          您也会和他们一样，在睿泽这里获取更大的成功。
        </div>
      </div>
      <div class="right-pic">
        <img src="@/assets/v1/user1.png" alt="" class="pics" />
        <img src="@/assets/v1/user2.png" alt="" class="pics" />
        <img src="@/assets/v1/user3.png" alt="" class="pics" />
        <img src="@/assets/v1/user4.png" alt="" class="pics" />
        <img src="@/assets/v1/user5.png" alt="" class="pics" />
        <img src="@/assets/v1/user6.png" alt="" class="pics" />
        <img src="@/assets/v1/user7.jpg" alt="" class="pics" />
        <img src="@/assets/v1/user8.png" alt="" class="pics" />
        <img src="@/assets/v1/user9.png" alt="" class="pics" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'cooperation',
  data() {
    return {}
  }
}
</script>
<style scoped>
.logo-container {
  text-align: left;
  background-color: #fff;
}
.index-help {
  width: 1200px;
  margin: 0 auto;
  padding-top: 110px;
  padding-bottom: 110px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.index-help .left {
  width: 40%;
}
.index-help .left .left-btitle {
  color: #172B4D;
  font-size: 36px;
  margin-bottom: 30px;
}
.index-help .left .left-stitle {
  color: #42526E;
  font-size: 16px;
  line-height: 24px;
}
.index-help .right-pic {
  width: 55%;
}
.index-help .right-pic .pics {
  width: 200px;
  display: inline-block;
  background: #FFFFFF;
  box-shadow: 0px 2px 12px 0px #D7DBDF;
  border-radius: 3px;
  margin-left: 15px;
  margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/cooperation.vue